import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { EmailVerification as EmailVerificationComponent } from 'components/auth/EmailVerification';

export const EmailVerification: React.FC = () => {
  const { emailVerificationData, emailVerificationRequired, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Si el usuario ya está autenticado, redirigir al dashboard
    if (user) {
      navigate('/');
      return;
    }

    // Si no se requiere verificación, redirigir al login
    if (!emailVerificationRequired || !emailVerificationData) {
      navigate('/auth/login');
      return;
    }
  }, [emailVerificationRequired, emailVerificationData, user, navigate]);

  // Mostrar loading mientras se verifica la redirección
  if (!emailVerificationData || user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600"></div>
      </div>
    );
  }

  const handleVerificationComplete = () => {
    // La navegación se manejará automáticamente cuando el user se actualice en el context
    console.log('Email verification completed');
  };

  return (
    <EmailVerificationComponent
      email={emailVerificationData.email}
      message={emailVerificationData.message}
      onVerificationComplete={handleVerificationComplete}
    />
  );
};